import clsx from "clsx";
import PropTypes from "prop-types";
import { CardTitle, Subtitle } from "components/atoms/Text";

const AffiliateCard = ({ icons, title, description, classNames }) => {
    return (
        <div className={clsx(
            "w-full p-6 phone:py-0 phone:pr-[30px] tablet:p-4",
            "rounded-lg",
            classNames
        )}>
            <div className={clsx(
                "w-fit p-[16px] bg-primary-surface rounded-lg phone:mb-6 mb-8"
            )}>
                <img src={`/icons/features/${icons}.svg`} width="32px" height="32px" alt={icons} />
            </div>
            <CardTitle classNames="desktop:!text-[28px] tablet:!text-[28px] phone:!text-[24px]">{title}</CardTitle>
            <Subtitle classNames="phone:mt-2 mt-3 tablet:pr-0 desktop:pr-[3px] phone:!tracking-normal phone:!text-[16px] !tracking-normal !leading-[27.2px]">{description}</Subtitle>
        </div>
    );
};

AffiliateCard.propTypes = {
    icons: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
};

export default AffiliateCard;